// extracted by mini-css-extract-plugin
export default {"base":"phone-numbers_base__TrE5q","phone-number":"phone-numbers_phone-number__E797A"};